export class ReservationGiftStatus{
    id?: number;
    status_initial_id: number;
    status_initial?: string;
    status_final_id: number;
    status_final?: string;
    action: string;
}

export class ReservationGiftStatusDefinition{
    id?: number;
    description: string;
}

export class ReservationGiftStatusWithDescription{
    id?: number;
    status_initial: string;
    status_finale: string;
    action: string;
}


// WEBPACK FOOTER //
// ./src/app/models/reservation-gift-status.model.ts